import React, { useState, useEffect, useCallback } from 'react';
import { Container, Stack, Alert, Button } from '@mui/material';
import WeightLogger from './WeightLogger';
import WeightGraph from './WeightGraph';
import api from '../api';
import { useLanguage } from '../i18n/LanguageContext';

const WeightTab: React.FC = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const [currentWeight, setCurrentWeight] = useState<number | undefined>();
  const [targetWeight, setTargetWeight] = useState<number | undefined>();
  const [fetchError, setFetchError] = useState(false);
  const { t } = useLanguage();

  const fetchData = useCallback(() => {
    setFetchError(false);
    Promise.allSettled([api.get('/profile'), api.get('/weight')])
      .then(([profileResult, weightResult]) => {
        if (profileResult.status === 'fulfilled') {
          setTargetWeight(profileResult.value.data.target_weight);
        }
        if (weightResult.status === 'fulfilled') {
          const wh: Array<{ date: string; weight: number }> = weightResult.value.data;
          if (wh && wh.length > 0) {
            setCurrentWeight(wh[wh.length - 1].weight);
          }
        }
        if (profileResult.status === 'rejected' || weightResult.status === 'rejected') {
          setFetchError(true);
        }
      });
  }, []);

  useEffect(() => {
    fetchData();
  }, [refreshKey, fetchData]);

  const handleWeightLogged = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (
    <Container maxWidth="sm" sx={{ pt: 2 }}>
      <Stack spacing={2}>
        {fetchError && (
          <Alert severity="error" action={
            <Button color="inherit" size="small" onClick={() => setRefreshKey(prev => prev + 1)}>{t.retry}</Button>
          }>
            {t.weightFetchFailed}
          </Alert>
        )}
        <WeightLogger
          onWeightLogged={handleWeightLogged}
          currentWeight={currentWeight}
          targetWeight={targetWeight}
        />
        <WeightGraph
          targetWeight={targetWeight}
          refreshKey={refreshKey}
        />
      </Stack>
    </Container>
  );
};

export default WeightTab;
